import React from 'react'

// Icons
import { LoaderSVG } from '../../atoms'

// Styles
import styles from './overlayLoader.module.scss'

const OverlayLoader = () => {
  return (
    <div className={styles.loaderWrapper} data-testid="overlay-loader">
      <LoaderSVG />
    </div>
  )
}

export default OverlayLoader
